import type { SearchResult } from "./SearchResult";
import {
	parseSubscriptionState,
	type SubscriptionState,
} from "./subscriptionState";
import {
	parseSubscriptionType,
	type SubscriptionType,
} from "./subscriptionType";

export interface SubscriptionJson {
	id: string;
	startAt: string;
	expireAt: string | null;
	agreementId: string;
	companyId: string;
	phone: string;
	phoneCountryCode: string;
	employeeId: string;
	lastName: string;
	firstName: string;
	type: string;
	activeSince: string;
	expiredSince: string | null;
	pricePerMonth: number;
	priceVatPerMoth: number;
	originId: string;
	state: string;
}

export interface Subscription {
	id: string;
	startAt: Date;
	expireAt: Date | null;
	agreementId: string;
	companyId: string;
	phone: string;
	phoneCountryCode: string;
	employeeId: string;
	lastName: string;
	firstName: string;
	type: SubscriptionType;
	pricePerMonth: number;
	priceVatPerMonth: number;
	state: SubscriptionState;
}

const mapSubscription = (json: SubscriptionJson): Subscription => ({
	id: json.id,
	startAt: new Date(json.startAt),
	expireAt: json.expireAt ? new Date(json.expireAt) : null,
	agreementId: json.agreementId,
	companyId: json.companyId,
	phone: json.phone,
	phoneCountryCode: json.phoneCountryCode,
	employeeId: json.employeeId,
	lastName: json.lastName,
	firstName: json.firstName,
	type: parseSubscriptionType(json.type),
	pricePerMonth: json.pricePerMonth,
	priceVatPerMonth: json.priceVatPerMoth,
	state: parseSubscriptionState(json.state),
});

export const mapSubscriptionSearchResult = (
	json: SearchResult<SubscriptionJson>,
): SearchResult<Subscription> => ({
	totalEntries: json.totalEntries,
	matches: json.matches.map(mapSubscription),
});

export const getValidSubscriptionJson = (): SubscriptionJson => ({
	id: "359a006a-9d22-43e8-84a6-ffddbc21dcb0",
	startAt: "2025-03-22T23:00:00Z",
	expireAt: null,
	agreementId: "1-3369898706",
	companyId: "1226629",
	phone: "93864800",
	phoneCountryCode: "+47",
	employeeId: "123456",
	lastName: "hansen",
	firstName: "kim",
	type: "JOULE",
	activeSince: "2025-03-23T13:50:50.335590199Z",
	expiredSince: null,
	pricePerMonth: 0,
	priceVatPerMoth: 0,
	originId: "test.sb-bigcustomer-subscriptions-backend",
	state: "ACTIVE",
});
